import { FC } from 'react';
import { useIntl } from 'react-intl';
import { faExternalLink } from '@fortawesome/pro-regular-svg-icons';
import { createBemBlockBuilder } from '@ebsco-ui/ebsco-ui';

import { ExternalLink, FeatureFlags, Icon } from '@app/components';
import { FEATURE } from '@app/constants';

interface PassthroughLinkProps {
  searchOption: string;
  query?: string;
}

const cnBem = createBemBlockBuilder(['searchResultsPage']);

export const PassthroughLink: FC<PassthroughLinkProps> = ({
  query = '*',
  searchOption,
}) => {
  const { $t } = useIntl();

  return (
    <FeatureFlags
      flagsToMatch={[{ name: FEATURE.passthroughlink }]}
      renderOn={flags => (
        <div
          className={cnBem('__passthrough-link')}
          data-auto="passthrough-link"
        >
          {$t(
            {
              id: 'searchResults.searchForMobius',
              defaultMessage: 'Search for <i>"{term}"</i> across <a>MOBIUS</a>',
            },
            {
              term: query,
              i: chunks => <i>{chunks}</i>,
              a: chunks => (
                <>
                  <ExternalLink
                    href={`${
                      flags?.[0]?.config?.consortia as string
                    }search?option=${searchOption}&query=${query}`}
                  >
                    {chunks}
                  </ExternalLink>
                  <Icon icon={faExternalLink} />
                </>
              ),
            }
          )}
        </div>
      )}
    />
  );
};
